<script lang="ts" setup>
import type { ProductQuestionData } from '~/types/product-questions'

defineProps<{
  productQuestionData: ProductQuestionData
}>()
</script>

<template>
  <div>
    <div class="mb-2.5 text-xs leading-[1.33] opacity-40 md:text-sm md:leading-[1.71]">
      Анонимный пользователь
    </div>

    <pre
      class="
        pre-wrap text-sm !font-medium leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base md:leading-normal
      "
    >{{ productQuestionData.attributes.question }}</pre>

    <div
      v-if="productQuestionData.attributes.answer"
      class="mt-3 rounded-2xl bg-main-light-gray p-4 md:mt-5 lg:p-5"
    >
      <div class="mb-3 text-xs leading-[1.33] text-main-green md:text-sm md:leading-[1.71]">
        Ответ продавца
      </div>

      <pre
        class="pre-wrap text-sm leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base md:leading-normal"
      >{{ productQuestionData.attributes.answer }}</pre>
    </div>
  </div>
</template>

<style scoped>
pre {
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}
</style>

